module.exports = __webpack_public_path__ + "img/thumbnail_EurasianLynx_f_normal.d6bb0dc2.png";